import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DUPLICATE_AB_TEST } from './api/mutation'

import type { UseDuplicateTest } from './types'
import type { DuplicateAbTestMutation, DuplicateAbTestMutationVariables } from 'gql/graphql'

export const useDuplicateTest = (): UseDuplicateTest => {
  const { t } = useTranslation('features/abTests', {
    keyPrefix: 'list.actions.duplicate',
  })
  const { enqueueSnackbar } = useSnackbar()

  const { mutateAsync } = useMutation<DuplicateAbTestMutationVariables, DuplicateAbTestMutation>({
    mutation: DUPLICATE_AB_TEST,
    onCompleted: async (data: DuplicateAbTestMutation) => {
      const errors = data.duplicateAbTest?.errors

      if (errors && errors.length > 0) {
        enqueueSnackbar(t('error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('success'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getAbTests'],
  })

  const duplicateAbTest: UseDuplicateTest['duplicateAbTest'] = id =>
    void mutateAsync({ input: { id } })

  return { duplicateAbTest }
}
